import { render, staticRenderFns } from "./question-02.vue?vue&type=template&id=78665aab&scoped=true&lang=pug"
var script = {}
import style0 from "./question-02.vue?vue&type=style&index=0&id=78665aab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78665aab",
  null
  
)

export default component.exports